// @flow
const TOKEN_KEY = "fa_token";

export default class CacheUtils {
  /** ** Authorization Token Helpers **** */

  static clearToken() {
    localStorage.removeItem(TOKEN_KEY);
  }

  static getAccessToken() {
    return localStorage.getItem(TOKEN_KEY);
  }

  static setAccessToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
    return token;
  }

  static setTokenExpiration(timestamp) {
    localStorage.setItem("tokenExpiration", timestamp);
  }

  static getTokenExpiration() {
    return localStorage.getItem("tokenExpiration");
  }

  static saveUserRequestedHref(url) {
    localStorage.setItem("loginHref", url);
  }

  static getUserRequestedHref() {
    return localStorage.getItem("loginHref");
  }

  static clearUserRequestedHref() {
    localStorage.removeItem("loginHref");
  }

  /** ** Synergy Helpers **** */

  static setSynergyToken(token) {
    localStorage.setItem("synergyToken", token);
  }

  static getSynergyToken() {
    return localStorage.getItem("synergyToken");
  }

  static setSynergyTokenExpiration(timestamp) {
    localStorage.setItem("synergyTokenExpires", timestamp);
  }

  static getSynergyTokenExpiration() {
    return localStorage.getItem("synergyTokenExpires") || null;
  }

  static setSynergyNonce(value) {
    localStorage.setItem("synergyNonce", value);
  }

  static getSynergyNonce() {
    return localStorage.getItem("synergyNonce") || null;
  }

  static clearSynergyCache() {
    localStorage.removeItem("synergyToken");
    localStorage.removeItem("synergyTokenExpires");
    localStorage.removeItem("synergyNonce");
  }

  /** *** VidSwap Helpers *** **/

  static setVidSwapToken(token) {
    localStorage.setItem("vidSwapToken", token);
  }

  static getVidSwapToken() {
    return localStorage.getItem("vidSwapToken");
  }

  static setVidSwapExpiration(expiration) {
    localStorage.setItem("vidSwapExpiration", expiration);
  }

  static clearVidSwapCache() {
    localStorage.removeItem("vidSwapToken");
    localStorage.removeItem("vidSwapExpiration");
  }

  /** *** Opponent Page Preference Helpers **** */

  static getLeague() {
    return localStorage.getItem("league");
  }

  static getTeamSort() {
    return localStorage.getItem("teamSort");
  }

  static setTeamSort(teamSort) {
    localStorage.setItem("teamSort", teamSort);
  }

  static getTeamFilter() {
    return localStorage.getItem("teamFilter");
  }

  static setTeamFilter(filter) {
    localStorage.setItem("teamFilter", filter);
  }

  /** Play Page Prefences * */
  static setPlaySeason(value) {
    localStorage.setItem("playSeason", JSON.stringify(value));
  }
  static getPlaySeason() {
    JSON.parse(localStorage.getItem("playSeason") || "null");
  }
  static setPlayTeam(value) {
    localStorage.setItem("playTeam", JSON.stringify(value));
  }
  static getPlayTeam() {
    JSON.parse(localStorage.getItem("playTeam") || "null");
  }
  static setPlaySeries(value) {
    localStorage.setItem("playSeries", JSON.stringify(value));
  }
  static getPlaySeries() {
    JSON.parse(localStorage.getItem("playSeries") || "null");
  }
  static setPlaySearch(value) {
    localStorage.setItem("playSearch", JSON.stringify(value));
  }
  static getPlaySearch() {
    JSON.parse(localStorage.getItem("playSearch") || "null");
  }
  static setPlaySortColumn(value) {
    localStorage.setItem("playSortColumn", JSON.stringify(value));
  }
  static getPlaySortColumn() {
    JSON.parse(localStorage.getItem("playSortColumn") || "null");
  }
  static setPlaySortDirection(value) {
    localStorage.setItem("playSortDirection", JSON.stringify(value));
  }
  static getPlaySortDirection() {
    JSON.parse(localStorage.getItem("playSortDirection") || "null");
  }
  static setPlayViewCount(value) {
    localStorage.setItem("playViewCount", JSON.stringify(value));
  }
  static getPlayViewCount() {
    JSON.parse(localStorage.getItem("playViewCount") || "null");
  }
  static setCurrentPlayBook(value) {
    localStorage.setItem("playbook", JSON.stringify(value));
  }
  static getCurrentPlayBook() {
    JSON.parse(localStorage.getItem("playbook") || "null");
  }
  static setPlaybookFolders(value) {
    localStorage.setItem("playbookFolders", JSON.stringify(value));
  }
  static getPlaybookFolders() {
    JSON.parse(localStorage.getItem("playbookFolders") || "{}");
  }
}
